import axios from "axios";

const VALIDATION_ERROR_REGEX =
  /The '(?:[^']*:)?([^']+)' element is invalid - The value '([^']*)' is invalid according to its datatype '(?:[^']*:)?([^']+)'/;

const INCOMPLETE_CONTENT_REGEX =
  /The element '(?:[^']*:)?([^']+)' .* has incomplete content. List of possible elements expected: '([^']+)'/;

const formatValidationError = (detail: string): string => {
  const validationMatch = VALIDATION_ERROR_REGEX.exec(detail);
  if (validationMatch) {
    const [, element, value] = validationMatch;
    return `'${element}' has an invalid value '${value}'.`;
  }

  const incompleteMatch = INCOMPLETE_CONTENT_REGEX.exec(detail);
  if (incompleteMatch) {
    const [, element] = incompleteMatch;
    return `'${element}' has incomplete content.`;
  }

  return detail;
};

interface RemitErrorResponse {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  instance?: string;
}

const isRemitErrorResponse = (data: unknown): data is RemitErrorResponse =>
  typeof data === "object" && data !== null && "status" in data;

export const DEFAULT_REMIT_ERROR_MESSAGE =
  "An unexpected error occurred. Please try again later.";

export const getRemitSubmissionErrorMessage = (err: unknown): string => {
  if (!axios.isAxiosError(err) || !err.response) {
    return DEFAULT_REMIT_ERROR_MESSAGE;
  }

  const responseData = err.response.data;

  if (
    isRemitErrorResponse(responseData) &&
    responseData.detail &&
    responseData.status &&
    responseData.status < 500
  ) {
    return formatValidationError(responseData.detail);
  }

  return DEFAULT_REMIT_ERROR_MESSAGE;
};
